type SvgProps = React.SVGProps<SVGSVGElement>;

export const InkleBooksHelp = (props: SvgProps) => (
  <svg
    {...props}
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.456522"
      y="0.456522"
      width="41.087"
      height="41.087"
      rx="20.5435"
      fill="white"
    />
    <rect
      x="0.456522"
      y="0.456522"
      width="41.087"
      height="41.087"
      rx="20.5435"
      stroke="#F3F3F5"
      stroke-width="0.913043"
    />
    <g clip-path="url(#clip0_6719_8004)">
      <path
        d="M14.913 25.1087C14.3515 25.1079 13.809 25.3149 13.3912 25.6907V13.6956C13.3912 12.4349 14.4131 11.413 15.6738 11.413H16.4347V25.1087H14.913ZM27.0869 11.413H25.5651V19.7826L23.663 17.8804L21.7608 19.7826V11.413H17.9565V25.1087H28.6086V12.9348C28.6086 12.094 27.9276 11.413 27.0869 11.413ZM13.3912 28.1522C13.3912 28.9929 14.0722 29.6739 14.913 29.6739H28.6086V26.6304H14.913C14.0722 26.6304 13.3912 27.3114 13.3912 28.1522Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6719_8004">
        <rect
          width="18.2609"
          height="18.2609"
          fill="white"
          transform="translate(11.8695 11.4131)"
        />
      </clipPath>
    </defs>
  </svg>
);
